//
//
//
//
//
//
//
//
//
//
//

import CustomerService from '@/api/customer.service';
import { Loading } from 'quasar';

export default {
    data() {
        return { iframeUrl: null, relogins: [] };
    },

    async mounted() {
        window.addEventListener('message', this.onSelbstauskunftMessage);
        await this.login();
    },

    beforeUnmount() {
        window.removeEventListener('message', this.onSelbstauskunftMessage);
    },

    methods: {
        async login() {
            Loading.show();
            try {
                const { data } = await CustomerService.getLoginForSelbstauskunft();
                this.iframeUrl = data.href;
            } catch (error) {
                this.$handleError(error);
                Loading.hide();
            }
        },

        onIframeLoad() {
            Loading.hide();
        },

        // The embedded Selbstauskunft talks to us in two cases:
        // - 'token-request': its session is about to expire (or just did). We
        //   answer with a fresh SSO token, the same one the login URL carries,
        //   and it renews in place without reloading the iframe.
        // - 'session-ended': it landed on its login page. We mint a fresh login
        //   URL and reload the iframe.
        // Both only while the portal session is alive, and rate-limited per
        // minute so a misconfigured instance cannot loop.
        async onSelbstauskunftMessage(event) {
            if (!this.iframeUrl || event.origin !== new URL(this.iframeUrl).origin) {
                return;
            }
            if (event.data?.source !== 'selbstauskunft') {
                return;
            }
            const now = Date.now();
            this.relogins = this.relogins.filter(at => now - at < 60000);
            if (this.relogins.length >= 3) {
                return;
            }

            if (event.data.event === 'token-request') {
                this.relogins.push(now);
                await this.sendToken(event);
            } else if (event.data.event === 'session-ended') {
                this.relogins.push(now);
                await this.login();
            }
        },

        // Only the iframe that asked gets the token, and only at its own origin.
        async sendToken(event) {
            try {
                const { data } = await CustomerService.getLoginForSelbstauskunft();
                const token = new URL(data.href).searchParams.get('jwt');
                if (token) {
                    event.source.postMessage({ source: 'serviceportal', event: 'sso-token', token }, event.origin);
                }
            } catch (error) {
                // no answer: the Selbstauskunft falls back to the reload path
            }
        },
    },
};
